var dataevent ='';(function () {

function getURLParameter(name) {
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
    );
}
    
var a = getURLParameter("st");
    


const queryString = window.location.search;
   
	
    var head = document.head;
    var link = document.createElement('link')
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = "https://halfstaff.org/widgets/us-half-staff-flags.css";
    head.appendChild(link);
    if (typeof moment === "undefined") {
        var momentjs = document.createElement('script');
        momentjs.src = "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.min.js";
        document.head.appendChild(momentjs);
    }
    if (!window.goToHalfstaff) {
        window.goToHalfstaff = function () {
            window.open("https://halfstaff.org/widget/", "_blank");
        };
    }
    var widgetRendered = false;
  
  
    function loadMomentAndProceed() {
        if (typeof moment === "undefined") {
            setTimeout(loadMomentAndProceed, 500);
        }
        else {
            if (!widgetRendered) {

			    var size = "half";
				var widgets = document.getElementsByClassName("halfstaffwidget_container");
                var dt = moment().format("MMM. D, YYYY");
                var tm = moment().format("hh:mm a");
                for(var i = 0; i < widgets.length; i++) {
                    widgets[i].innerHTML = "<a href='https://halfstaff.org/widget/'><div class='halfstaffwidget_time'>" + tm + "</div>"
                        + "<div class='halfstaffwidget_date'>" + dt + "</div>"
                        + "<div class='halfstaffwidget_message'>"+dataevent+"</div>"
                        + "<div class='halfstaffwidget_linkdiv'></div></a>";
                }

                widgetRendered = true;
                
               
				

		
				
				
				
				
				
            }
        }
    }



if(dataevent){
    
    document.write("<div class='halfstaffwidget_container half' onclick='window.goToHalfstaff();'>");
    document.write("</div>");    
    
}else{
  
      document.write("<div class='halfstaffwidget_container full' onclick='window.goToHalfstaff();'>");
    document.write("</div>");
    
    
}







    setTimeout(loadMomentAndProceed, 500);
})();